import { render, staticRenderFns } from "./Accent.vue?vue&type=template&id=0bda7c0a&scoped=true&"
import script from "./Accent.vue?vue&type=script&lang=js&"
export * from "./Accent.vue?vue&type=script&lang=js&"
import style0 from "./Accent.vue?vue&type=style&index=0&id=0bda7c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda7c0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
